import { useAuthContext } from "context/auth-context";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from 'react';
import Basic from "layouts/authentication/sign-in";

export const AuthGuard = (props) => {
    const { children } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const authContextData = useAuthContext();

    const { isAuthenticated, loaded } = authContextData;

    const ignore = useRef(false);

    useEffect(() => {
     
        if (loaded) {
            ignore.current = true;
            if (!isAuthenticated) {
                if (!location.pathname.includes('auth')) {
                    navigate('/auth/login', {
                        replace: true,
                        state: { continueUrl: location.pathname !== '/' ? location.pathname : undefined },
                    });
                }
                
            }
            else {
                if (location.pathname.includes('auth')) {
                    navigate('/', {
                        replace: true,
                        state: { continueUrl: location.pathname !== '/' ? location.pathname : undefined },
                    });
                }
               
            }
        }
        
    }, [isAuthenticated, loaded])
    
    return children;
}